import React from "react";
import rootStore, { RootStore } from "csi/state/rootStore";

export const RootStoreContext = React.createContext(rootStore);

export function useStore(): RootStore {
	return React.useContext(RootStoreContext);
}
